import { useCallback, useEffect, useState } from 'react';
import { axiosInstance } from '../helpers/axios';
import { IRubric } from '../types/types';

// рубрики «Полезного» ведёт сотрудник в кабинете, поэтому список берётся с бэкенда
export const useFetchRubrics = () => {
    const [rubrics, setRubrics] = useState<IRubric[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const fetchRubrics = useCallback(() => {
        setIsLoading(true);
        return axiosInstance
            .get<IRubric[]>('/v1/rubric/')
            .then((response) => setRubrics(response.data))
            .catch((error) => console.error(error))
            .finally(() => setIsLoading(false));
    }, []);

    useEffect(() => {
        fetchRubrics();
    }, [fetchRubrics]);

    return { rubrics, isLoading, refetch: fetchRubrics };
};
